



























import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import firebase from 'firebase'
import MainMixin from '../mixins/MainMixin'
import MessageWrapper from '../components/messages/MessageWrapper.vue'
import EventBus from '../event-bus'
import { rdb } from '../firebase/init'

@Component({
  components: {
    MessageWrapper,
  },
})
export default class Messages extends Mixins(MainMixin) {
  get tabs() {
    if (this.$store.getters.manager) {
      return [{ title: 'Send', value: 'send' }, { title: 'Managers', value: 'managers' }]
    } return undefined
  }

  // async sendMessageToDb() {
  //   if (!this.sendMessage) return false
  //   rdb.ref(`locations/${this.location}/messages/managers`).push({
  //     // @ts-ignore
  //     user: this.uid,
  //     text,
  //     created,
  //   });
  // }

  message = ''

  participants = [
    {
      id: 'user1',
      name: 'Matteo',
      imageUrl: 'https://avatars3.githubusercontent.com/u/1915989?s=230&v=4',
    },
    {
      id: 'user2',
      name: 'Support',
      imageUrl: 'https://avatars3.githubusercontent.com/u/37018832?s=200&v=4',
    },
  ]

  titleImageUrl = 'https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png'

  // messageList = [
  //   { type: 'text', author: 'me', data: { text: 'Say yes!' } },
  //   { type: 'text', author: 'user1', data: { text: 'No.' } },
  // ]

  get messageList() {
    return this.allMessages.map((message:any) => message.message)
  }

  newMessagesCount = 0

  isChatOpen = true // to determine whether the chat window should be open or closed

  showTypingIndicator = ''

  alwaysScrollToBottom = true // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)

  messageStyling = true

  sendMessage(text:any) {
    if (text.length > 0) {
      this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
      this.onMessageWasSent({
        author: 'support', type: 'text', data: { text, meta: '06-06-2019 12:12' }, suggestions: [' reply one', 'reply 2'],
      })
    }
  }

  async onMessageWasSent(message:any) {
    // called when the user sends a message
    await rdb.ref(`locations/${this.location}/messages/managers`).push({
      // @ts-ignore
      user: this.uid,
      message,
      created: firebase.database.ServerValue.TIMESTAMP,
    });
    // this.messageList = [...this.messageList, message]
  }

  openChat() {
    // called when the user clicks on the fab button to open the chat
    this.isChatOpen = true
    this.newMessagesCount = 0
  }

  closeChat() {
    // called when the user clicks on the botton to close the chat
    this.isChatOpen = false
  }

  handleScrollToTop() {
    // called when the user scrolls message list to top
    // leverage pagination for loading another page of messages
  }

  handleOnType() {
    console.log('Emit typing event')
  }

  // editMessage(message:any) {
  //   // @ts-ignore
  //   const m = this.messageList.find(z => z.id === message.id)
  //   // @ts-ignore
  //   m.isEdited = true;
  //   // @ts-ignore
  //   m.data.text = message.data.text;
  // }

  writeMessage(to:string, text:string) {
    const created = new Date().toISOString()
    return rdb.ref(`locations/${to}/managers`).push({
      // @ts-ignore
      user: this.uid,
      text,
      created,
    });
  }

  allMessages = []

  created() {
    this.$rtdbBind('allMessages', rdb.ref(`locations/${this.location}/messages/managers`))
  }
}

